import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private _lang: string = 'en';
  private _jsonURL = 'static/assets/i18n/';

  constructor(
    private http: HttpClient
  ) { }

  get lang(): string {
    return this._lang;
  }

  set lang(value: string) {
    this._lang = value;
  }

  getLangFile(comp: string, path?: string) {
    let langPath = this._jsonURL + this.lang + '/' + comp + '.json';

    if (path) {
      langPath = path;
    }
    return this.http.get(langPath)
      .pipe(catchError(err => of({})));
  }

}
